import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useUserCompany from "./useUserCompany";
import { getFormVisibilityMap } from "../api/formVisibilityApi";
import { formVisibilityActions } from "../store/form-visibility/form-visibility-slice";

export default function useFormVisibility({
  form,
  commonForm = false,
  opeType,
  keyValue,
  type,
  useDynamicFields = false,
}) {
  const dispatch = useDispatch();
  const username = useSelector((s) => s.user.username);
  const companyId = useUserCompany()?.comId;

  useEffect(() => {
    if (!commonForm && !useDynamicFields) return;

    // we’ll use `active` to ignore any response after the next effect run
    let active = true;

    (async () => {
      dispatch(formVisibilityActions.setLoading(true));

      const payload = {
        form: commonForm
          ? useDynamicFields
            ? `${form}_${opeType}`
            : form
          : form,
        key: useDynamicFields ? keyValue : "default",
        type: useDynamicFields ? type : "1",
        user: username,
        company: companyId,
      };

      try {
        const visibilityMap = await getFormVisibilityMap(payload);

        if (!active) {
          return;
        }

        dispatch(
          formVisibilityActions.setFormVisibility({
            form: commonForm ? `${form}_${opeType}` : form,
            map: visibilityMap,
          }),
        );
      } finally {
        if (active) {
          dispatch(formVisibilityActions.setLoading(false));
        }
      }
    })();

    // cleanup runs before the next effect, so it will mark `active = false`
    return () => {
      active = false;
    };
  }, [
    form,
    commonForm,
    opeType,
    keyValue,
    type,
    useDynamicFields,
    username,
    companyId,
    dispatch,
  ]);
}
